import { inject, Injectable, signal } from '@angular/core';
import { StorageService } from './storage.service';

export interface User {
  userId: number;
  email: string;
  firstName: string;
  lastName: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private storage = inject(StorageService);

  private readonly USER_KEY = 'auth-user';
  public currentUser = signal<User | null>(this.getUser());

  normalizaUser(user: any): User {
    return {
      userId: user.id,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
    };
  }

  getUser(): User | null {
    const user = this.storage.getItem(this.USER_KEY);
    return user ? JSON.parse(user) : null;
  }

  setUser(user: User): void {
    this.storage.setItem(this.USER_KEY, JSON.stringify(user));
    this.currentUser.set(user);
  }

  clearUser(): void {
    this.storage.removeItem(this.USER_KEY);
    this.currentUser.set(null);
  }
}
